const initialState = {
  RegionValues: [],
  CountryValues: [],
  ActionRestriction: null,
  SelectedRegionValue: null,
  countryValues: [],
  selectedCountryValue: null,
  restrictionValues: null,
  countrySelectBoolean: false,
};

const AdminRestrictPermission = (state = initialState, action) => {
  switch (action.type) {
    case "ActionLevel":
      state = { ...state, ActionRestriction: action.payload };
      return state;
    case "geoLevelRegionAction":
      state = { ...state, RegionValues: action.payload };
      // state = { ...state, pageNo: action.payload };
      return state;
    case "selectRegionAction":
      state = { ...state, SelectedRegionValue: action.payload };
      // state = { ...state, pageNo: action.payload };
      return state;
    case "GetCountryValuesAction":
      state = { ...state, countryValues: action.payload };
      return state;
    case "SelectedCountryValueAction":
      state = { ...state, selectedCountryValue: action.payload };
      return state;
    case "ActionRestrictionValue":
      state = { ...state, restrictionValues: action.payload };
      return state;
    case "CountryActionBoolean":
      state = { ...state, countrySelectBoolean: action.payload };
      return state;
    // case "reloadHistoryPage":
    //   state = { ...state, reloadPage: action.payload };
    //   return state;
    default:
      return state;
  }
};

export default AdminRestrictPermission;
